'use strict';

import main from './lib/BamGameUtils';

export default main;

